import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

// Menu das Configurações.
//
// As 45 telas de ajuste existiam sem caminho: a tela de Configurações abria
// direto em Conta e nao tinha navegacao, entao Agentes, Etiquetas ou Caixas de
// Entrada so se alcancava decorando a URL ou pela busca global.
//
// O agrupamento e por assunto, do ponto de vista de quem usa, nao pela pasta em
// que o codigo mora: por isso a distribuicao de conversas fica em Pessoas (e
// sobre quem atende) e a pontuacao de leads fica em IA, que e o que ela e.
//
// `featureFlag`, `adminOnly` e `installationTypes` escondem o item de quem nao
// pode abrir (o filtro fica em getSettingsNavGroups, no settingsCatalog.js): um item que so levaria a uma tela de acesso negado (ou que
// devolve para as conversas) nao ajuda ninguem.
export const SETTINGS_NAV_GROUPS = [
  {
    id: 'channels',
    labelKey: 'SETTINGS_NAV.GROUPS.CHANNELS',
    items: [
      {
        id: 'inboxes',
        labelKey: 'SETTINGS_NAV.ITEMS.INBOXES',
        icon: 'i-ri-inbox-2-line',
        routeName: 'settings_inbox_list',
        adminOnly: true,
      },
      {
        id: 'voip_calls',
        labelKey: 'SETTINGS_NAV.ITEMS.VOIP_CALLS',
        icon: 'i-ri-phone-line',
        routeName: 'voip_calls_settings',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.VOIP_CALLS,
      },
      // Motivos de encerramento é uma aba de Chamadas (a rota antiga
      // /voip-disposition redireciona para ela), então não tem item próprio.
    ],
  },
  {
    id: 'people',
    labelKey: 'SETTINGS_NAV.GROUPS.PEOPLE',
    items: [
      {
        id: 'agents',
        labelKey: 'SETTINGS_NAV.ITEMS.AGENTS',
        icon: 'i-ri-user-line',
        routeName: 'agent_list',
        adminOnly: true,
      },
      {
        id: 'teams',
        labelKey: 'SETTINGS_NAV.ITEMS.TEAMS',
        icon: 'i-ri-group-line',
        routeName: 'settings_teams_list',
        adminOnly: true,
      },
      {
        id: 'custom_roles',
        labelKey: 'SETTINGS_NAV.ITEMS.CUSTOM_ROLES',
        icon: 'i-ri-shield-user-line',
        routeName: 'custom_roles_list',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.CUSTOM_ROLES,
      },
      {
        id: 'assignment',
        labelKey: 'SETTINGS_NAV.ITEMS.ASSIGNMENT',
        icon: 'i-ri-share-forward-line',
        routeName: 'assignment_policy_index',
        adminOnly: true,
      },
    ],
  },
  {
    id: 'support',
    labelKey: 'SETTINGS_NAV.GROUPS.SUPPORT',
    items: [
      {
        id: 'canned',
        labelKey: 'SETTINGS_NAV.ITEMS.CANNED',
        icon: 'i-ri-chat-quote-line',
        routeName: 'canned_list',
      },
      {
        id: 'labels',
        labelKey: 'SETTINGS_NAV.ITEMS.LABELS',
        icon: 'i-ri-price-tag-3-line',
        routeName: 'labels_list',
        adminOnly: true,
      },
      {
        // featureFlag igual ao da rota: sem ele o item levava a uma tela
        // bloqueada nas contas com a flag desligada.
        id: 'macros',
        labelKey: 'SETTINGS_NAV.ITEMS.MACROS',
        icon: 'i-ri-flashlight-line',
        routeName: 'macros_wrapper',
        featureFlag: FEATURE_FLAGS.MACROS,
      },
      {
        id: 'automation',
        labelKey: 'SETTINGS_NAV.ITEMS.AUTOMATION',
        icon: 'i-ri-brain-line',
        routeName: 'automation_list',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.AUTOMATIONS,
      },
      {
        id: 'workflows',
        labelKey: 'SETTINGS_NAV.ITEMS.WORKFLOWS',
        icon: 'i-ri-git-branch-line',
        routeName: 'conversation_workflows_index',
        adminOnly: true,
      },
      {
        // Logs e automacoes de comentario so se achavam pelo Hub, por atalho
        // ou dentro de Integracoes > Meta. Ficam aqui, onde se procura.
        id: 'automation_logs',
        labelKey: 'SETTINGS_NAV.ITEMS.AUTOMATION_LOGS',
        icon: 'i-ri-file-list-3-line',
        routeName: 'automation_logs',
      },
      {
        id: 'instagram_comments',
        labelKey: 'SETTINGS_NAV.ITEMS.INSTAGRAM_COMMENTS',
        icon: 'i-ri-instagram-line',
        routeName: 'instagram_automation_index',
        adminOnly: true,
      },
      {
        id: 'facebook_comments',
        labelKey: 'SETTINGS_NAV.ITEMS.FACEBOOK_COMMENTS',
        icon: 'i-ri-facebook-circle-line',
        routeName: 'facebook_automation_index',
        adminOnly: true,
      },
      {
        // Resolucao automatica e campos obrigatorios ao encerrar. A tela existia
        // so pela URL desde que a sidebar antiga saiu (PR #483).
        id: 'conversation_resolution',
        labelKey: 'SETTINGS_NAV.ITEMS.CONVERSATION_RESOLUTION',
        icon: 'i-ri-checkbox-circle-line',
        routeName: 'conversation_workflow_index',
        adminOnly: true,
      },
      {
        id: 'sla',
        labelKey: 'SETTINGS_NAV.ITEMS.SLA',
        icon: 'i-ri-time-line',
        routeName: 'sla_list',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.SLA,
      },
    ],
  },
  {
    id: 'ai',
    labelKey: 'SETTINGS_NAV.GROUPS.AI',
    items: [
      // A configuração da IA mora em Ajustes da IA, por categoria (D1 do
      // redesign da Central): a Central em si ficou só com as filas.
      {
        id: 'ai_settings',
        labelKey: 'SETTINGS_NAV.ITEMS.AI_SETTINGS',
        icon: 'i-ri-sparkling-2-line',
        routeName: 'ai_settings',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.AI_ACTION_CENTER,
      },
      {
        id: 'captain',
        labelKey: 'SETTINGS_NAV.ITEMS.CAPTAIN',
        icon: 'i-ri-sparkling-line',
        routeName: 'captain_settings_index',
        adminOnly: true,
      },
      {
        id: 'agent_bots',
        labelKey: 'SETTINGS_NAV.ITEMS.AGENT_BOTS',
        icon: 'i-ri-robot-line',
        routeName: 'agent_bots',
        adminOnly: true,
      },
      {
        id: 'lead_scoring',
        labelKey: 'SETTINGS_NAV.ITEMS.LEAD_SCORING',
        icon: 'i-ri-bar-chart-box-line',
        routeName: 'lead_scoring_settings',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.LEAD_SCORING,
      },
    ],
  },
  {
    id: 'account',
    labelKey: 'SETTINGS_NAV.GROUPS.ACCOUNT',
    items: [
      {
        id: 'general',
        labelKey: 'SETTINGS_NAV.ITEMS.GENERAL',
        icon: 'i-ri-settings-3-line',
        routeName: 'general_settings_index',
        adminOnly: true,
      },
      {
        id: 'attributes',
        labelKey: 'SETTINGS_NAV.ITEMS.ATTRIBUTES',
        icon: 'i-ri-file-list-2-line',
        routeName: 'attributes_list',
        adminOnly: true,
      },
      {
        id: 'billing',
        labelKey: 'SETTINGS_NAV.ITEMS.BILLING',
        icon: 'i-ri-bank-card-line',
        routeName: 'billing_settings_index',
        adminOnly: true,
        // Fora do cloud a tela manda de volta para as conversas sem aviso.
        installationTypes: [INSTALLATION_TYPES.CLOUD],
      },
      {
        id: 'audit',
        labelKey: 'SETTINGS_NAV.ITEMS.AUDIT',
        icon: 'i-ri-history-line',
        routeName: 'auditlogs_list',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
      },
      {
        // E a tela de SSO (SAML) da empresa, so para admin e com SAML ligado.
        // A troca de senha da pessoa fica em Meus dados.
        id: 'security',
        labelKey: 'SETTINGS_NAV.ITEMS.SECURITY',
        icon: 'i-ri-lock-line',
        routeName: 'security_settings_index',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.SAML,
        installationTypes: [
          INSTALLATION_TYPES.CLOUD,
          INSTALLATION_TYPES.ENTERPRISE,
        ],
      },
    ],
  },
  {
    id: 'integrations',
    labelKey: 'SETTINGS_NAV.GROUPS.INTEGRATIONS',
    items: [
      {
        // As telas de cada integracao ficam fora do menu de proposito: sao 13 e
        // ja abrem a partir desta lista. Poe-las aqui inflaria sem ajudar.
        id: 'integrations',
        labelKey: 'SETTINGS_NAV.ITEMS.INTEGRATIONS',
        icon: 'i-ri-plug-line',
        routeName: 'settings_applications',
        adminOnly: true,
        featureFlag: FEATURE_FLAGS.INTEGRATIONS,
      },
    ],
  },
  {
    // Por ultimo e separado: estes ajustes sao da pessoa, nao da empresa.
    // Misturar os dois e o que faz alguem mudar sem querer algo que vale para
    // todo mundo.
    id: 'profile',
    labelKey: 'SETTINGS_NAV.GROUPS.PROFILE',
    items: [
      {
        id: 'profile',
        labelKey: 'SETTINGS_NAV.ITEMS.PROFILE',
        icon: 'i-ri-account-circle-line',
        routeName: 'profile_settings_index',
      },
    ],
  },
];
